import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { LogOutIcon } from '@instacart/ids-core'
import { FulfillmentTestingCenterIcon, OpenInIcon } from '@instacart/ids-core'
import { spacing } from '@retailer-platform/shared-components'
import { NavItem } from 'gin-and-tonic/containers/nav/components/NavItem'
import { AppDevPortalFooterLinkAccessControl } from 'sections/dev-portal/DevPortalSection.configuration'
import clientEnv from 'utils/global/clientEnv'

const iconStyle = css({
  marginRight: spacing.X16,
  marginLeft: 'auto',
  width: '18px',
  height: '18px',
})

export const RetailerNavFooterContent: FunctionComponent = () => (
  <>
    {clientEnv.PUBLIC_CLIENT_ENVIRONMENT == 'production' && (
      <NavItem
        isMainItem
        Icon={FulfillmentTestingCenterIcon}
        title="app.devPortal.nav.header"
        accessControl={AppDevPortalFooterLinkAccessControl}
        route="app-dev-portal"
        navBadge={<OpenInIcon css={iconStyle} color="systemGrayscale00" />}
      />
    )}
    <NavItem isMainItem Icon={LogOutIcon} route="logout" title="logout" />
  </>
)
